import React from 'react';

import { CampaignPerformanceTotals } from 'apis/merchant-gateway/insights/campaigns-performance/types';
import MonetaryAmount from 'common/formatting/MonetaryAmount';

import { CampaignAnalyticsDateRageFilter } from './CampaignAnalyticsDateRageFilter';
import { CampaignAnalyticsMetrics } from './CampaignAnalyticsMetrics';
import { useCampaignModuleContext } from '../../context';
import { DateRange } from '../../types';

export const CampaignListMetrics = ({
  campaignPerformance,
  isLoading,
  dateRange,
  setDateRange,
}: {
  campaignPerformance: CampaignPerformanceTotals;
  isLoading?: boolean;
  dateRange: DateRange;
  setDateRange: (dateRange: DateRange) => void;
}) => {
  const { currency } = useCampaignModuleContext();

  const { totalOrders, avgBasketSize, totalSpend, returningCustomers, newCustomers, totalSales, avgCostPerOrder } =
    campaignPerformance;

  return (
    <CampaignAnalyticsMetrics
      title="Campaign performance"
      headerAction={<CampaignAnalyticsDateRageFilter onUpdate={setDateRange} dateRange={dateRange} />}
      colored
      isLoading={isLoading}
      metrics={{
        totalSales: <MonetaryAmount amount={totalSales} currency={currency} />,
        totalSpend: <MonetaryAmount amount={totalSpend} currency={currency} />,
        totalOrders,
        newCustomers: newCustomers ?? 0,
        returningCustomers: returningCustomers ?? 0,
        averageBasketSize: <MonetaryAmount amount={avgBasketSize} currency={currency} />,
        averageCostPerOrder: <MonetaryAmount amount={avgCostPerOrder} currency={currency} />,
      }}
    />
  );
};
